export const colors = [
    "#1f77b4",
    "#aec7e8",
    "#ff7f0e",
    "#ffbb78",
    "#2ca02c",
    "#98df8a",
    "#d62728",
    "#ff9896",
    "#9467bd",
    "#c5b0d5",
    "#8c564b",
    "#c49c94",
    "#e377c2",
    "#f7b6d2",
    "#7f7f7f",
    "#c7c7c7",
    "#bcbd22",
    "#dbdb8d",
    "#17becf",
    "#9edae5",
]

export const noTagColor = "#979797"

// generate an index between 0-19 based on ascii codes for each letter in a tag (for repeatability)
export function getColorIndex(tagName) {
    const asciiCodes = tagName.split("").map(letter => letter.charCodeAt(0))
    const sum = asciiCodes.reduce((p, c) => p + c, 0)
    return sum % colors.length
}

export function genColor(tagName) {
    if (!tagName) return ""

    return colors[getColorIndex(tagName)]
}

export function getShortName(teamId, props) {
    return Object.keys(props.teams).reduce((acc, c) => props.teams[c].id === teamId ? props.teams[c].shortname : acc, "")
}

export function labelToMap(tagLabel) {
    const [ firstEl, secondEl ] = parseLabel(tagLabel)
    return {
        shortname: secondEl && firstEl,
        tagName: secondEl || firstEl,
    }
}

export function parseLabel(tagLabel) {
    return tagLabel.split(':', 2).map(item => item.trim())
}

export function prependTag(shortname, tagName) {
    return shortname && tagName ? `${shortname}:${tagName}` : shortname || tagName
}

export function getLabel(tag, props) {
    const shortname = getShortName(tag.teamId, props)
    return prependTag(shortname, tag.name)
}

export function readLabel(tagLabel) {
    const parsedLabel = parseLabel(tagLabel)
    return parsedLabel.length > 1 ? parsedLabel[1] : parsedLabel[0]
}


// WEBPACK FOOTER //
// ./src/util/tag_utils.js